<script lang="jsx">
import Config from './config.vue';
import EditDelta from './edit-delta.vue';
import planPropsMixin from '@/plans/mx/plan-props';
import commonMixin from '@/plans/ZCM/mixin';
import { isAutoAddable } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  mixins: [planPropsMixin, commonMixin],
  render() {
    if (this.$context.is.edit) {
      if (this.$context.is.addQty && isAutoAddable()) {
        return <EditDelta {...this.$attrs} />;
      } else {
        return <Config {...this.$attrs} />;
      }
    }
    return <Config {...this.$attrs} />;
  },
};
</script>

